import { ExportOutlined, ImportOutlined } from "@ant-design/icons";
import { ResourceProps } from "@refinedev/core";

export const RESOURCE_NAMES: Record<string, string> = {
  exchange: "api/v1/exchange_money_requests/get-list",
  
  cryptoWithdraw: "api/v1/withdrawal-requests",
  paymentRequests: "api/v1/payment_requests",
  invoicePayables: "api/v1/invoice_payables",
  paymentOrders: "api/v1/payment_orders",
  invoiceReceivables: "api/v1/invoice_receivables",

  companies: "api/v1/companies",
  wallets: "api/v1/wallets",
  configFees: "",
  version: "api/v1/version-review",
  banks: "api/v1/banks/no_default_accounts",
  bankAccounts: "api/v1/bank_accounts/non_default",
  currencies: "api/v1/currencies",
  customers: "api/v1/users",
  customersEdit: "api/v1/users",
  transactionsHistory: "api/v1/transactions_history",

  beneficiariesRemitters: "api/v1/beneficiaries-remitters",
  beneficiariesRemittersCustomers: "api/v1/beneficiaries-remitters",
};

export const ADMIN_RESOURCE_NAMES = [
  RESOURCE_NAMES.invoicePayables,
  RESOURCE_NAMES.invoiceReceivables,
  RESOURCE_NAMES.customers,
];

export const EXCLUSIVE_CLIENT_RESOURCES = [RESOURCE_NAMES.transactionsHistory];

export const RESOURCES: ResourceProps[] = [
  {
    name: RESOURCE_NAMES.paymentRequests,
    list: "/payment-request",
    meta: {
      canDelete: true,
      label: "Send Money",
      icon: <ImportOutlined />,
    },
  },
  {
    name: RESOURCE_NAMES.invoicePayables,
    list: "/invoice-payables",
    meta: {
      canDelete: true,
      label: "Invoices (Payables)",
      icon: <ImportOutlined />,
    },
  },
  {
    name: RESOURCE_NAMES.exchange,
    list: "/exchange",
    meta: {
      canDelete: true,
      label: "Exchange Money",
      icon: <ImportOutlined />,
    },
  },
  {
    name: RESOURCE_NAMES.cryptoWithdraw,
    list: "/crypto-withdrawal",
    meta: {
      canDelete: true,
      label: "Crypto Withdrawal",
      icon: <ImportOutlined />,
    },
  },
  {
    name: RESOURCE_NAMES.paymentOrders,
    list: "/payment-order",
    meta: {
      canDelete: true,
      label: "Request Money",
      icon: <ExportOutlined />,
    },
  },
  {
    name: RESOURCE_NAMES.transactionsHistory,
    list: "/transactions-history",
    meta: {
      label: "Transactions history",
      icon: <ExportOutlined />,
    },
  },
  {
    name: RESOURCE_NAMES.invoiceReceivables,
    list: "/invoice-receivables",
    meta: {
      canDelete: true,
      label: "Invoices (Receivables)",
      icon: <ExportOutlined />,
    },
  },
  {
    name: RESOURCE_NAMES.companies,
    list: "/company",
    meta: {
      canDelete: true,
      label: "Provider",
      parent: "Directory",
    },
  },
  {
    name: RESOURCE_NAMES.companies,
    list: "/company/:id",
    meta: {
      canDelete: true,
      label: "Provider",
      parent: "Directory",
      hide: true,
      parentName: RESOURCE_NAMES.companies
    },
  },
  // {
  //   name: RESOURCE_NAMES.wallets,
  //   list: "/wallets",
  //   meta: {
  //     label: "Provider Wallet",
  //     parent: "Directory",
  //   },
  // },
  {
    name: RESOURCE_NAMES.configFees,
    list: "/config-fees",
    meta: {
      label: "Config Fees",
      parent: "Directory",
    },
  },
  {
    name: RESOURCE_NAMES.banks,
    list: "/banks",
    meta: {
      canDelete: true,
      label: "System Banks",
      parent: "Directory",
    },
  },
  {
    name: RESOURCE_NAMES.currencies,
    list: "/currencies",
    meta: {
      canDelete: true,
      label: "Currencies",
      parent: "Directory",
      hide: true,
    },
  },
  {
    name: RESOURCE_NAMES.customers,
    list: "/customers",
    meta: {
      label: "Customers",
      parent: "Directory",
    },
  },
  {
    name: RESOURCE_NAMES.customersEdit,
    list: "/customers/:id",
    meta: {
      label: "Customers",
      parent: "Directory",
      hide: true,
      parentName: RESOURCE_NAMES.customers
    },
  },
  {
    name: RESOURCE_NAMES.bankAccounts,
    list: "/bank-accounts",
    meta: {
      label: "Bank Accounts",
      parent: "Directory",
      canDelete: true,
      hide: true,
      parentName: RESOURCE_NAMES.customers
    },
  },
  {
    name: RESOURCE_NAMES.beneficiariesRemitters,
    list: "/beneficiaries-remitters",
    meta: {
      label: "Beneficiaries & Remitters",
      parent: "Directory",
      canDelete: true,
      hide: true,
      parentName: RESOURCE_NAMES.customers
    },
  },
  {
    name: RESOURCE_NAMES.customersEdit,
    list: "/customers/:id/beneficiaries",
    meta: {
      label: "Beneficiaries & Remitters",
      parent: "Directory",
      canDelete: true,
      hide: true,
      parentName: RESOURCE_NAMES.customers
    },
  },
  {
    name: RESOURCE_NAMES.version,
    list: "/version-review",
    meta: {
      label: "Version Review",
      parent: "Directory",
    },
  },
];
